import React from 'react';

import ModalDialog from '../components/modal_dialog';
import Auth from '../utils/auth';

class Defect extends React.Component {
  state = {
    showDetails: false
  }

  showDetails = (e) => {
    e.preventDefault();
    this.setState({ showDetails: true});
  }

  handleCloseModal = () => {
    this.setState({ showDetails: false });
  }

  render() {
    const { defect } = this.props;
    const { showDetails } = this.state;

    return (
      <div className='component-defect'>
        <div className='thumbnail-container'>
          <img src={defect.image.url} className='thumbnail' onClick={this.showDetails} />
          {
            defect.youtube_embed_code_source &&
            <div className='video-icon-container' onClick={this.showDetails}>
              <i className='fa fa-youtube-play' onClick={this.showDetails}/>
            </div>
          }
        </div>
        <div className="content">
          <div className='title'>{defect.title}</div>
          <div className='description'>
            {defect.description.substr(0, 200)}
            {(defect.description.length > 200) && '...'}
          </div>
          <a onClick={this.showDetails} className='btn view-details'>
            { defect.youtube_embed_code_source ? 'View Video' : 'Enlarge Image'}
          </a>
          {
            (Auth.isAdmin() || Auth.isContentEditor()) &&
            <div className='actions'>
              <a href={`/defects/${defect.id}/edit`}>Edit</a>{' '}
              <a href={`/defects/${defect.id}`} data-method='delete' data-confirm='Are you sure?'>Destroy</a>
            </div>
          }
        </div>

        {
          showDetails &&
          <ModalDialog onClose={this.handleCloseModal}>
            <div className='details-modal'>
              {
                (defect.youtube_embed_code_source.length > 0) ?
                  <iframe width="100%" 
                          height="600" 
                          src={defect.youtube_embed_code_source}
                          frameborder="0" 
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                          allowfullscreen></iframe>
                :
                  <img src={defect.image.url} />

              }
              <div className='description'>{defect.description}</div>
            </div>
          </ModalDialog>
        }
      </div>
    );
  }
}

export default Defect;